var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('PageTitle',{attrs:{"title":"Kennslutímabil"}}),_c('i',[_vm._v(" Smelltu á einkenni kennslutímabils til þess að vinna með tímabils tengdar upplýsingar s.s. námsgagnalista, einkunnareglur, stýringar ofl. ")]),_c('TermSearch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }